import { getReferralCampaignDetail } from '../../../api/referralCampaignsApi'
import ReferralCampaignDescriptions from '../../../components/referral-campaigns/referral-campaign-descriptions/referral-campaign-descriptions'
import { ReduxStore } from '../../../store'
import { IReferralCampaign } from '../share-type'
import { Space } from 'antd'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Outlet } from 'react-router-dom'
import { compose } from 'redux'

const ReferralCampaign = () => {
  const params = useParams()
  const [referralCampaignId] = useState<string | undefined>(params?.id)
  const [referralCampaign, setReferralCampaign] = useState<IReferralCampaign>()
  useEffect(() => {
    if (referralCampaignId) {
      getReferralCampaignDetail(Number(referralCampaignId)).then(res => {
        setReferralCampaign(res)
      })
    }
  }, [referralCampaignId])

  return (
    <Space className="desc-wrapper" orientation="vertical" align="center" size={16}>
      {referralCampaign && <ReferralCampaignDescriptions referralCampaign={referralCampaign} />}
      <Outlet />
    </Space>
  )
}

const mapStateToProps = (state: ReduxStore) => {
  return {
    activeCities: state.cities.activeCities,
    locale: state.global.locale,
  }
}

const withConnect = connect(mapStateToProps)

export default compose(withConnect)(ReferralCampaign)
